<template>
<v-layout row justify-center class="billingModule">
  <v-flex md3 class="sidebar">
    <aside>
      <span class="patient_profile">
        <h4>{{ptName}}</h4>
        <h5>{{ptAge}}/{{ptGender}}
          <span v-if='ptPlace === "undefined" || ptPlace ===  "null"'></span>
          <span v-else>, {{ptPlace}}</span>
       </h5>
      </span>
      <ul>

        <li :class="(this.fromCompleted) ? 'fromCompleted' : 'notfromCompleted'">
          <router-link
          :to="{
            name: 'vitalsPost',
            params: {
              status:`${vitalsStatus}`,
              appId: `${appId}`,
              ptId: `${ptId}`}
            }"
            >
            Vitals
          </router-link>
        </li>
<li style="color:gray">
            Investigation
        </li>
        <li class="active">
          <router-link  :to="{ name: 'prescription', params: {appId: `${appId}`,ptId: `${ptId}`} }">Prescriptions</router-link>
        </li>
        <!-- <li >
          <router-link :to="{ name: 'billing', params: {appId: `${appId}`,ptId: `${ptId}`}}">Billing</router-link>
        </li> -->
      </ul>
    </aside>
  </v-flex md3>
  <v-flex md9 pl-3 pr-3>
    <v-layout row>
      <v-flex md12>
        <div id="printableArea" v-if='this.status === true'>
          <!-- <embed :src="prescriptionPdf.split('?')[0]" id="pdf" type='application/pdf' /> -->
          <object
            :data="prescriptionPdf.split('?')[0]"
            id="pdf"
            >
            </object>
            <!-- <pdf :src="prescriptionPdf"></pdf> -->
        </div>
        <div v-else>
          <div class="emptyState">
            <img :src='image' alt="">
            <h1>Prescription not generated yet</h1>
          </div>
        </div>
      </v-flex md12>
    </v-layout row justify-center>
  </v-flex>
</v-layout>
</template>
<script>
import Vue from 'vue'
import {
  api
} from '../api.js';
import {
  mapState
} from 'vuex';
import {axios, get, post} from 'axios';
import emptyState from '../../static/prescription.png'
import pdf from 'vue-pdf'

export default {
  data() {
    return {
      prescriptionPdf: '',
      status: '',
      image: emptyState
    }

  },
  components: {
    pdf
  },
  mounted() {
    // const array1 = this.$store.state.Waiting_list_pd
    // var found = array1.find(function(r) {
    //   return r.person_id = 4074;
    // });
    // console.log(found.billing);
      get(api + `/v2/today_pdf?appointment_id=${this.appId}`)
        .then(res=>{
          this.status = res.data.status
           this.prescriptionPdf = res.data.pdf
        })
    // console.log(this.appId);
  },
  computed: {
    ...mapState(['appointment_id']),
      appId: function() {
        if (this.$route.params.appId !== null) {
          return this.$route.params.appId
        }
      },
      vitalsStatus: function() {
        const vitalsStatus = localStorage.getItem("vitalsStatus")
          return vitalsStatus
      },
      appId: function() {
        if (this.$route.params.appId !== null) {
          return this.$route.params.appId
        }
      },
      ptId: function() {
        if (this.$route.params.ptId !== null) {
          return this.$route.params.ptId
        }
      },
      ptName: function() {
        return localStorage.getItem("ptName")
      },
      ptAge: function() {
        if(localStorage.getItem("ptAge")==='null'){
          return ''
        }
        return localStorage.getItem("ptAge")
      },
      ptGender: function() {
        return localStorage.getItem("ptGender")
      },
      ptPlace: function() {
        let pTplaceFromLS = localStorage.getItem("ptPlace");
        let checkLSLength = pTplaceFromLS.length > 0

        return (checkLSLength) ? pTplaceFromLS : 'undefined'
      },
      fromCompleted: function() {
        const string = "completed queue"
        const from = localStorage.getItem("from_where")
        return from.includes(string)
      }
  },
  methods: {


    // printPrescription(id) {
    //   let token = localStorage.getItem('token', this.token);
    //   // let token=localStorage.getItem('token')
    //   // store.state.token=localStorage.getItem('token')
    //   // let x=this.id;
    //   // alert(x)
    //   let appointment_id = this.appointment_id
    //   // alert(appointment_id)
    //
    //   $.ajax({
    //     // url: api+'/v2/today_pdf?appointment_id=3274',
    //     url: api + `/v2/today_pdf?appointment_id=${appointment_id}`,
    //     method: 'GET',
    //     headers: {
    //       "token": token
    //     },
    //     success: (res) => {
    //       // this.bills = res;
    //       if (res == true)
    //         this.prescriptionPdf = res.pdf;
    //       else
    //         document.getElementById('emptyState').innerHTML = "No prescription"
    //     }
    //   })
    // },
    // printpdf(){
    //     // alert()
    //     $('#pdf').val()
    // },
    //         printDiv(divName) {
    //      var printContents = document.getElementById(divName).innerHTML;
    //      var originalContents = document.body.innerHTML;

    //      document.body.innerHTML = printContents;

    //      window.print();

    //      document.body.innerHTML = originalContents;
    // }


  }
}
</script>
<style media="screen" scoped>
.billingModule {
  min-height: 99vh;
}

#example-1 {
  font-size: 20px;
  padding: 20px;
  margin-left: 1.5rem;
}

#example-2 {
  /*padding: 20px;*/
}

#detail {
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  margin: 10px;
  padding: 8px;
  width: 65%;
  margin-left: 2rem;
}

#charge {
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  padding: 8px;
  width: 15%;
  margin-left: 5rem;
}

#partiallyPaid {
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  padding: 8px;
  width: 15%;
}

.card__title {
  background-color: #018FFF;
  color: white;
  font-size: 80px;
}

ul {
  list-style: none;
}

.fa-times-circle-o {
  color: #8080808a;
}

.invoiceTotals {
  padding: 20px;
  margin-left: 1.5rem;
  text-align: right;
  padding-right: 5rem;
}

.invoiceTotals>h3 {
  margin: 10px 0px;
}

.sidebar {
  background-color: #383B3F;
  color: #fff;
}

.sidebar ul li {
  padding: 1rem;
}

.sidebar ul li a {
  color: white;
  text-decoration: none;
}

.sidebar .active {
  background-color: #F2994A;
}

.patient_profile>h4 {
  padding: 10px 10px 2px 10px;
}

.patient_profile>h5 {
  padding: 0 10px 10px;
}

.fa-inr {
  margin-left: 1rem;
  margin-right: 0.5rem;
}

.card__actions {
  justify-content: space-around;
}

#emptyState {
  display: flex;
  justify-content: center;
  font-size: 16px;
  height: 100vh
}
#pdf {
  width: 100%;
  height: 90vh;
  margin-top: 1rem
}
.emptyState {
  text-align: center;
  padding: 16rem 10rem;
}
.emptyState img {
  width: 15%;
}
.fromCompleted {
   pointer-events:none;
   opacity:0.6;
}
</style>



// WEBPACK FOOTER //
// src/components/prescription.vue